module.exports = __webpack_public_path__ + "static/media/studio_pallet_truck_ep_15_lithium_manitou_012.e8a5c6d1.png";